var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.779,
    height: 9.083,
    viewBox: "0 0 60.779 9.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27678",
    "data-name": "Group 27678",
    transform: "translate(597.023 11296.619) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27676",
    "data-name": "Group 27676",
    transform: "translate(-586.5 129.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56790",
    "data-name": "Path 56790",
    d: "M18765.744,11483.147h59.719",
    transform: "translate(-17643 -321)",
    fill: "none",
    stroke: "#0f1b30",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56791",
    "data-name": "Path 56791",
    d: "M18817.67,11478.535l4.012,4.012-4.012,4.011",
    transform: "translate(-17639.219 -320.399)",
    fill: "none",
    stroke: "#0f1b30",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPrev);
export default __webpack_public_path__ + "static/media/nav-prev.2f4de7e2a469b67557b8a9c288b1c1aa.svg";
export { ForwardRef as ReactComponent };